import { Grid, IconButton } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { ZendeskChatHeaderIcon } from '../zendesk/zendesk-chat-header-icon.component';
import { headerStyles } from './header-styles';

interface HeaderProps {
  icon: React.ReactNode;
  onIconClicked: () => void;
  onZendeskChatClicked?: () => void;
  companyIcon: React.ReactNode;
}

export const Header = ({ onIconClicked, onZendeskChatClicked, icon, companyIcon }: HeaderProps) => {
  const classes = headerStyles();
  const auth = useAuth();
  const { i18n } = useTranslation();

  return (
    <Grid
      container
      direction='row'
      alignItems='center'
      justifyContent={'flex-start'}
      className={classes.header}
      style={{
        height: '60px',
        backgroundColor: '#fff',
      }}
      padding={companyIcon ? '0px 24px' : '0px 16px '}
    >
      {companyIcon && <Grid>{companyIcon}</Grid>}

      {(onZendeskChatClicked || icon) && (
        <Grid item className={classes.rightIconsContainer}>
          {onZendeskChatClicked && (
            <IconButton
              className={classes.accountIcon}
              onClick={() => onZendeskChatClicked()}
              aria-label={String(i18n.t('open_chat') || 'Open chat')}
            >
              <ZendeskChatHeaderIcon />
            </IconButton>
          )}
          {icon && (
            <IconButton
              className={classes.accountIcon}
              onClick={() => onIconClicked?.()}
              aria-label={auth.isLoggedIn ? String(i18n.t('go_to_my_account')) : ''}
            >
              {icon}
            </IconButton>
          )}
        </Grid>
      )}
    </Grid>
  );
};
